const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

if (urlParams.get("sanity_preview") === "true") {
  window.addEventListener("scroll", () => sendScrollPosition());
  window.addEventListener("message", handleScroll);

  document.addEventListener("DOMContentLoaded", editLinks);
  document.addEventListener("DOMContentLoaded", closeCookieBanner);

  function sendScrollPosition(x, y) {
    window.parent.postMessage(
      {
        type: "scrollPosition",
        x: x || window.scrollX,
        y: y || window.scrollY,
      },
      "*"
    );
  }

  function handleScroll(event) {
    if (event.data.type === "scrollTo") {
      window.scrollTo(event.data.x, event.data.y);
    }
  }

  function editLinks() {
    document.querySelectorAll("a").forEach((link) => {
      addQueryParamsTo(link);
      resetScrollPositionAfterClickOn(link);
    });
  }

  function addQueryParamsTo(link) {
    let currentHref = new URL(link.href);

    if (currentHref.origin !== window.location.origin) return;

    currentHref.searchParams.set("sanity_preview", "true");
    currentHref.searchParams.set(
      "sanity_preview_secret",
      urlParams.get("sanity_preview_secret")
    );

    link.href = currentHref.toString();
  }

  function resetScrollPositionAfterClickOn(link) {
    link.addEventListener("click", () => sendScrollPosition("0", "0"));
  }

  function closeCookieBanner() {
    let cookieBanner = document.querySelector("aside.banner-tray");

    if (cookieBanner) {
      cookieBanner.style.display = "none";
    }
  }
}
